import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";
import { useGetHomeQuery } from "@/store/rest_api";
import { useNavigate } from "react-router-dom";
import React from "react";

export function TrialLapsedBanner() {
  const { data: user } = useGetHomeQuery();
  const navigate = useNavigate();

  const subscriptionStatus = user?.activeOrganisation?.subscriptionStatus;

  if (subscriptionStatus !== "TRIAL_LAPSED") {
    return null;
  }

  return (
    <Alert variant="destructive" className="border-0">
      <AlertTriangle className="h-4 w-4" />
      <AlertTitle>Trial Period Ended</AlertTitle>
      <AlertDescription className="flex items-center justify-between">
        <div>
          <p>Your free trial has ended. Subscribe to a plan to continue using the platform.</p>
          <p className="text-xs mt-1">Your data is safe and will be restored when you subscribe.</p>
        </div>
        <Button onClick={() => navigate("/manage-organisation/plans")} size="sm" className="ml-4">
          Choose a Plan
        </Button>
      </AlertDescription>
    </Alert>
  );
}
